export default __webpack_public_path__ + "static/media/the-eddy-copy.57bc6edc.png";